(ns web3.screens.marketing
  (:require [web3.view :as v]
            [web3.i18n :as i]
            [web3.components.drawer :as drawer]
            [web3.components.text :as text]
            [reagent.core :as r]
            [web3.components.widgets :as widgets]
            [web3.components.branch :as branch]
            [web3.persistence.queries :as q]
            [web3.forms.fields :as fields]
            [web3.env :as env]
            [web3.queries.root :as q-root]))

(v/defview tell-a-friend
  {:header {:title (i/get :i/share-centriq)}}
  []
  (let [{:keys [referralLink]} (:me (q-root/me))
        {:keys [state]} (r/current-component)
        select! #(let [^js el (:input @state)
                       content-length (some-> referralLink (count))]
                   (doto el
                     (.focus)
                     (aset "selectionStart" 0)
                     (aset "selectionEnd" (+ 2 content-length))))
        copy! (fn []
                (select!)
                (let [copied? (js/document.execCommand "copy")]
                  (when copied?
                    (swap! state assoc :ephemeral-helptext "Copied")
                    (js/setTimeout #(swap! state dissoc :ephemeral-helptext)
                                   3000))))]

    [:div.pad-all-3
     [:div.text-size-32.margin-v-4.weight-light.line-h-34
      (i/to-do (str "Do you love " (:partner/name env/config) "?"
                    " Share that love!"))]
     [:div.text-size-24.weight-medium.line-h-26
      [:p (i/to-do "Just give your friends this link")]]
     [text/input {:ref #(when % (swap! state assoc :input %))
                  :on-click select!
                  :value "https://www.homeserve.com/app"
                  :encoding {:decode fields/decode-referral-link}
                  :ephemeral-helptext (:ephemeral-helptext @state)}]
     [widgets/black-button
      {:on-click copy!
       :class "margin-bottom-3 margin-top-4"}
      (i/get :i/copy-link)]



     ]))
